import { render, staticRenderFns } from "./MapaPlotagem.vue?vue&type=template&id=976211f2&lang=true&"
import script from "./MapaPlotagem.vue?vue&type=script&lang=js&"
export * from "./MapaPlotagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports